import createReducer from '../../helpers/CreateReducer';
import { ProfileConstants, ApiConstants } from '../../constants/actions';

export interface ProfileState {
  selectedProfileIndex: number;
  noPersistance: boolean;
  isEmailVerified: boolean | null;
  username: string;
  firstName: string;
  lastName: string;
  emailAddress: string;
  phoneNumber: string;
  jobTitle: string | null;
}

interface ChangeProfileTabAction {
  type: string;
  index: number;
}

interface UserInfoSuccessAction {
  type: string;
  userInfo: Partial<ProfileState>;
}

interface UpdateUserInfoSuccessAction {
  type: string;
  payload: Partial<ProfileState>;
}

export const getInitialState = (): ProfileState => ({
  selectedProfileIndex: 0,
  noPersistance: true,
  isEmailVerified: null,
  username: '',
  firstName: '',
  lastName: '',
  emailAddress: '',
  phoneNumber: '',
  jobTitle: null
});

export default createReducer(getInitialState, {
  [`${ProfileConstants.CHANGE_SELECTED_PROFILE_TAB}`]: (
    state,
    action: ChangeProfileTabAction
  ) => ({
    ...state,
    selectedProfileIndex: action.index
  }),
  [`${ApiConstants.GET_USER_INFORMATION}_SUCCESS`]: (
    state,
    { userInfo }: UserInfoSuccessAction
  ) => ({
    ...state,
    ...userInfo
  }),
  [`${ProfileConstants.CLEAR_PROFILE}`]: () => getInitialState(),
  [`${ApiConstants.UPDATE_USER_INFORMATION}_SUCCESS`]: (
    state,
    { payload }: UpdateUserInfoSuccessAction
  ) => ({
    ...state,
    ...payload
  })
});
